<template>
  <div>
    <el-popover
      v-model="visible"
      ref="popover"
      placement="bottom"
      :width="popoverWidth"
      trigger="manual">
      <ul class="subNoPopover">
        <li
          v-for="(item, index) in subNoList"
          :key="index"
          @click="subNoItemClick(item)"
          v-if="!subNo || item.includes(subNo)">
          <span>{{item}}</span>
        </li>
      </ul>
    </el-popover>
    <el-tooltip
      v-model="isShowBigChar"
      placement="right"
      effect="dark"
      content="大写锁定已打开"
      manual>
      <el-input
        v-popover:popover
        v-bind="$attrs"
        autofocus
        clearable
        v-model="subNo"
        ref="refSubNo"
        autocomplete="on"
        type="text"
        @focus="focusSubNo"
        @blur="blurSubNo"
        @keypress.native="subNoKeyPress"
        @keyup.enter.native="enterSubNo"
        @change="changeSubNo"
        tabindex="1"
      />
    </el-tooltip>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {
    getQueryVariable
  } from '@/utils';

  export default {
    name: 'subNoInputList',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: [
      'value',
      'pageName',
      'popoverWidth'
    ],
    data() {
      return {
        visible: false,
        subNo: this.value,
        subNoList: [],
        clickItemSubNo: '',
        isSubNoItemClick: false,
        focused: false,
        isShowBigChar: false,
        querySubOrderNo: undefined,
      };
    },
    computed: {
      ...mapGetters([
        'subNoListObj',
      ]),
    },
    watch: {
      $route: {
        handler() {
          this.getQuerySubOrderNo();
        },
        immediate: true,
      },
      value(newValue) {
        this.subNo = newValue;
      },
      subNoListObj: {
        handler(newValue) {
          if (newValue) {
            const pageName = this.pageName;
            this.subNoList = newValue[pageName] || [];
            const {
              querySubOrderNo,
            } = this;
            if (querySubOrderNo) {
              if (!this.subNoList.includes(querySubOrderNo)) {
                this.subNoList.unshift(querySubOrderNo);
              }
            }
          }
        },
        immediate: true,
        deep: true,
      },
      subNo() {
        const subNoList = this.subNoList;
        if (subNoList.length === 0) {
          return;
        }
        const subNo = this.subNo;
        if (subNo) {
          let isExistSubNo = false;
          if (subNo !== this.clickItemSubNo) {
            this.isSubNoItemClick = false;
          }
          for (let row of this.subNoList) {
            if (row.includes(subNo)) {
              isExistSubNo = true;
              break;
            }
          }
          if (isExistSubNo) {
            if (this.visible === false && this.isSubNoItemClick === false) {
              this.visible = true;
            }
          } else {
            if (this.visible === true) {
              this.visible = false;
            }
          }
        } else {
          this.visible = this.focused;
        }
      }
    },
    methods: {
      getQuerySubOrderNo() {
        const querySubOrderNo = getQueryVariable('subOrderNo');
        this.querySubOrderNo = querySubOrderNo;
        this.subNo = querySubOrderNo || '';
        this.changeSubNo(this.subNo);
        if (querySubOrderNo) {
          if (!this.subNoList.includes(querySubOrderNo)) {
            this.subNoList.unshift(querySubOrderNo);
          }
        }
      },
      getInput() {
        return this.$refs.refSubNo;
      },
      focus() {
        this.getInput().focus();
      },
      focusSubNo() {
        this.focused = true;
        const subNoList = this.subNoList;
        if (subNoList.length > 0) {
          const subNo = this.subNo;
          if (!subNo) {
            this.visible = true;
            return;
          }
          let isExistSubNo = false;
          for (let row of subNoList) {
            if (row.includes(subNo)) {
              isExistSubNo = true;
              break;
            }
          }
          if (isExistSubNo) {
            this.visible = true;
          }
        }
      },
      blurSubNo() {
        this.focused = false;
        this.visible = false;
      },
      subNoItemClick(value) {
        this.clickItemSubNo = value;
        this.isSubNoItemClick = true;
        this.subNo = value;
        this.visible = false;
        this.changeSubNo(value);
      },
      changeSubNo(value) {
        this.$emit('change', value)
      },
      enterSubNo() {
        this.changeSubNo(this.subNo);
        this.$emit('enter');
      },
      subNoKeyPress(event) {
        let e = event || window.event;
        let keyCode = e.keyCode || e.which;
        let isShift = e.shiftKey || keyCode === 16 || false; //shift键是否按住
        if (((keyCode >= 65 && keyCode <= 90) && !isShift)
          || ((keyCode >= 97 && keyCode <= 122) && isShift)) {
          this.isShowBigChar = true;
        } else {
          this.isShowBigChar = false;
        }
      },
    }
  };
</script>

<style lang="less" scoped>
  .subNoPopover {
    li {
      padding: 5px 0;
      cursor: pointer;
      &:hover {
        background: #f5f7fa;
      }
    }
  }
</style>
